const DOWNLOAD_SIZE_MEGABITS = 10;
const FALLBACK_DOWNLINK = 0.001;

const ELAPSED_UNITS = [
  { label: 'years', seconds: 31536000 },
  { label: 'months', seconds: 2592000 },
  { label: 'days', seconds: 86400 },
  { label: 'hours', seconds: 3600 },
  { label: 'minutes', seconds: 60 },
];

export interface ElapsedTime {
  count: number | string;
  label: string;
}

export function elapsedSince(date: string | number | Date | null): ElapsedTime {
  if (!date) return { count: '', label: 'never' };

  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  const unit = ELAPSED_UNITS.find(candidate => seconds / candidate.seconds > 1);

  return unit
    ? { count: Math.floor(seconds / unit.seconds), label: unit.label }
    : { count: Math.floor(seconds), label: 'seconds' };
}

// 'pwa' when launched from the home screen, 'browser' otherwise
export function displayExperience(): 'pwa' | 'browser' {
  let result: 'pwa' | 'browser' = 'browser'
  try {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      result = 'pwa'
    }
  }
  catch (e) {}
  return result
}

export function connectionSpeedMbps(): number {
  return (navigator as Navigator & { connection?: { downlink?: number } })
    .connection?.downlink || FALLBACK_DOWNLINK;
}

export function estimatedDownloadTime(mbps: number): string {
  const seconds = DOWNLOAD_SIZE_MEGABITS / (mbps / 8);
  return new Date(seconds * 1000).toISOString().substr(11, 8);
}
